import isObject from '@/helpers/isObject';

/* eslint-disable no-param-reassign */
export function target() {
  return (
    ['Header', 'BannerWithMenu'].includes(this.module) &&
    Array.isArray(this.data.menuLinks)
  );
}

export function migrate() {
  this.data.menuLinks = this.data.menuLinks.map((menuLink) => {
    if (
      !Object.hasOwnProperty.call(menuLink, 'selectDirectLinkOrPage') ||
      isObject(menuLink.linkUrl)
    ) {
      return menuLink;
    }

    const { selectDirectLinkOrPage, metaPageSelect, anchorId } = menuLink;

    delete menuLink.selectDirectLinkOrPage;
    delete menuLink.metaPageSelect;
    delete menuLink.anchorId;

    if (selectDirectLinkOrPage === 'link') {
      return {
        ...menuLink,
        linkUrl: {
          type: 'externalLink',
          value: menuLink.linkUrl,
        },
      };
    }

    if (selectDirectLinkOrPage === 'pages') {
      return {
        ...menuLink,
        linkUrl: {
          type: 'page',
          value: metaPageSelect,
        },
      };
    }

    if (selectDirectLinkOrPage === 'anchor') {
      return {
        ...menuLink,
        linkUrl: {
          type: 'anchor',
          value: anchorId,
        },
      };
    }
    return menuLink;
  });
}
